import ReactGA from "react-ga4";

const TRACKING_ID = import.meta.env.VITE_APP_GOOGLE_ANALYTIC_KEY;

export const initGoogleAnalytic = () => {
  if (!ReactGA.isInitialized) {
    ReactGA.initialize(TRACKING_ID, {
      gaOptions: {
        debug_mode: !import.meta.env.VITE_APP_GOOGLE_ANALYTIC_ENABLED,
        debug: !import.meta.env.VITE_APP_GOOGLE_ANALYTIC_ENABLED,
      },
      gtagOptions: {
        debug_mode: !import.meta.env.VITE_APP_GOOGLE_ANALYTIC_ENABLED,
        debug: !import.meta.env.VITE_APP_GOOGLE_ANALYTIC_ENABLED,
      },
    });
  }
};

export const resetGoogleAnalytic = () => {
  if (ReactGA.isInitialized) {
    ReactGA.reset();
  }
};

export const sendGoogleAnalyticEvent = (options) => {
  ReactGA.event(options);
};
